<template>
  <div class="template-home">
    <TopSportsBar v-if="getGameConsole === 'classic'" />
    <PreliveSection v-if="getGameConsole === 'classic'" />
    <PreliveSectionAmerican v-if="getGameConsole === 'american'"/>
  </div>
</template>

<script>
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import TopSportsBar from '@/components/center_widgets/Previews/TopSportsBar.vue'
import {mapGetters} from "vuex";
import PreliveSectionAmerican from "@/components/american/PreliveSectionAmerican.vue";

const PreliveSection = () => ({
  component: import('@/components/center_widgets/Previews/PreliveSection.vue'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'PreliveView',
  components: {PreliveSectionAmerican, TopSportsBar, PreliveSection },
  computed: {
    ...mapGetters({
      'getGameConsole': 'settings/getGameConsole',
    }),
  }
}
</script>

<style scoped>
.template-home{
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.tabs-content-area {
  min-height: 600px;
}
</style>
